var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
/// <reference path="../../../typings/tsd.d.ts" /> 
var warsApp;
(function (warsApp) {
    var directives;
    (function (directives) {
        var ManageForm = /** @class */ (function (_super) {
            __extends(ManageForm, _super);
            function ManageForm() {
                var _this = _super !== null && _super.apply(this, arguments) || this;
                _this.templateUrl = './app/views/directives/manageForm/manageForm.html';
                _this.controller = [
                    '$scope', 'angularLoadService', 'formSectionService', 'ModalService', '$http',
                    'dataSourceService', 'formService', 'formDataService', 'securityMatrixService', 'growl',
                    'formCodeFunctionService', 'customDivService',
                    'manageProcessDataConfigurationService', 'apiActionService', 'deleteService', ManageFormController
                ];
                return _this;
            }
            return ManageForm;
        }(directives.BaseForm));
        directives.ManageForm = ManageForm;
        var ManageFormModel = /** @class */ (function (_super) {
            __extends(ManageFormModel, _super);
            function ManageFormModel() {
                return _super !== null && _super.apply(this, arguments) || this;
            }
            ManageFormModel.prototype.setupImplementedForm = function () {
            };
            ManageFormModel.prototype.addAssignmentSection = function () {
                var manageSection = this.addSection(1 /* Assignment */);
                manageSection.assignmentConfiguration = this.formService.createAssigmentConfiguration();
                manageSection.assignmentConfiguration.isReadOnly = false;
                this.save();
            };
            ManageFormModel.prototype.addTimeTrackers = function () {
                var section = this.addSection(2 /* TimeTrackers */);
                this.save();
            };
            ManageFormModel.prototype.addDocuments = function () {
                var documentSection = this.addSection(3 /* Documents */);
                documentSection.manageDocumentsConfiguration = this.formService.createManageDocumentConfiguration();
                documentSection.manageDocumentsConfiguration.canUploadDocumentsSecurityMatrix = this.securityMatrixService.createSecurityMatrix(false);
                documentSection.title = "Documents";
                documentSection.manageDocumentsConfiguration.canUploadDocumentsSecurityMatrix.matrixType = 1 /* HideOrShow */;
                this.save();
            };
            ManageFormModel.prototype.addFieldHistory = function () {
                this.addSection(4 /* FieldHistory */);
                this.save();
            };
            ManageFormModel.prototype.addEmbeddedFormSection = function () {
                var manageSection = this.addSection(5 /* EmbeddedForm */);
                this.save();
            };
            ManageFormModel.prototype.addApiGrid = function () {
                var manageSection = this.addSection(12 /* ApiGrid */);
                this.save();
            };
            ManageFormModel.prototype.addNotificationsSent = function () {
                this.addSection(6 /* NotificationsSent */);
                this.save();
            };
            ManageFormModel.prototype.addProcessData = function () {
                var processDataSection = this.addSection(7 /* ProcessData */);
                processDataSection.manageProcessDataConfiguration = this.manageProcessDataConfigurationService.createManageProcessDataConfiguration();
                processDataSection.manageProcessDataConfiguration.showHistory = false;
                this.save();
            };
            ManageFormModel.prototype.addProcessEvent = function () {
                var processEventSection = this.addSection(13 /* ProcessEvent */);
                processEventSection.manageProcessEventConfiguration = this.manageProcessDataConfigurationService.createManageProcessEventConfiguration();
                this.save();
            };
            ManageFormModel.prototype.addRelatedProcess = function () {
                this.addSection(8 /* RelatedProcess */);
                this.save();
            };
            ManageFormModel.prototype.addReview = function () {
                this.addSection(9 /* Review */);
                this.save();
            };
            ManageFormModel.prototype.addStatuses = function () {
                var manageSection = this.addSection(10 /* Statuses */);
                manageSection.manageStatusConfiguration = this.formService.createManageStatusConfiguration();
                manageSection.manageStatusConfiguration.autoExpand = false;
                manageSection.manageStatusConfiguration.allowThreadedComments = false;
                manageSection.manageStatusConfiguration
                    .manageStatusType = 5 /* StatusesAndStatesFlat */;
                this.save();
            };
            ManageFormModel.prototype.addThreadedComments = function () {
                var manageSection = this.addSection(11 /* ThreadedComments */);
                manageSection.commentThreadConfiguration = this.formService.createCommentThreadConfiguration();
                this.save();
            };
            ManageFormModel.prototype.addSection = function (sectionType) {
                var newManageSection = this.formService.createManageSection();
                newManageSection.manageSectionType = sectionType;
                newManageSection.position = this.formConfiguration.myManageSections.length;
                newManageSection.title = "New Manage Section Title";
                newManageSection.sectionDisplayType = 1 /* Panel */;
                newManageSection.securityMatrix = this.securityMatrixService.createSecurityMatrix(false, false);
                this.formConfiguration.myManageSections.push(newManageSection);
                return newManageSection;
            };
            return ManageFormModel;
        }(directives.BaseFormModel));
        directives.ManageFormModel = ManageFormModel;
        var ManageFormController = /** @class */ (function (_super) {
            __extends(ManageFormController, _super);
            function ManageFormController(scope, angularLoader, formSectionService, modalService, httpService, dataSourceService, formService, formDataService, securityMatrixService, growl, formCodeFunctionService, customDivService, manageProcessDataConfigurationService, apiActionService, deleteService) {
                var _this = this;
                scope.model = new ManageFormModel(angularLoader, formSectionService, modalService, httpService, dataSourceService, formService, scope.process, formDataService, growl, formCodeFunctionService, customDivService, manageProcessDataConfigurationService, apiActionService, securityMatrixService, deleteService, scope);
                _this = _super.call(this, scope) || this;
                return _this;
            }
            return ManageFormController;
        }(directives.BaseFormController));
        directives.ManageFormController = ManageFormController;
    })(directives = warsApp.directives || (warsApp.directives = {}));
})(warsApp || (warsApp = {}));
warsApp.registerDirective('ManageForm', []);
